import { makeAutoObservable } from 'mobx';
import { StreamChat } from 'stream-chat';

import { resetAllStore } from './resetAllStore';
import { chatService } from '../../chat/services/chatService';
import { ChatUser } from '../../chat/interfaces/chatInfo';
import { goTo } from '../utils/angularUtils';

const apiKey = process.env.APP_STREAM_API_KEY as string;

class ChatStore {
  user: ChatUser | null = null;
  userToken: string | null = null;
  chatClient: StreamChat | null = null;
  activeChannelId: string | undefined = undefined;
  unreadCount = 0;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.user = null;
    this.userToken = null;
    this.chatClient = null;
    this.activeChannelId = undefined;
    this.unreadCount = 0;
  }

  async initializeChat() {
    const { userInfo, token } = await chatService.getChatInfo();
    this.setUser(userInfo);
    this.setUserToken(token);

    const client = StreamChat.getInstance(apiKey, {
      timeout: 0, // fix canceled requests after 3s (default)
    });

    const { id, name, imageUrl } = userInfo;
    const connectionResponse = await client.connectUser(
      { id, name, image: imageUrl },
      token,
    );

    this.setUnreadCount(connectionResponse?.me?.total_unread_count || 0);

    client.on((event) => {
      if (event.total_unread_count !== undefined) {
        this.setUnreadCount(event.total_unread_count);
      }
    });

    this.setChatClient(client);
  }

  setUnreadCount(unreadCount: number) {
    this.unreadCount = unreadCount;
  }

  setUser(user: ChatUser) {
    this.user = user;
  }

  setUserToken(userToken: string) {
    this.userToken = userToken;
  }

  setChatClient(chatClient: StreamChat) {
    this.chatClient = chatClient;
  }

  setActiveChannelId(activeChannelId: string | undefined) {
    this.activeChannelId = activeChannelId;
  }

  resetChat() {
    if (this.chatClient) {
      this.chatClient.disconnectUser();
      this.setDefaultValues();
    }
  }

  async openChatWithCustomer(customerId: number) {
    const channelId = await chatService.getChannelId(customerId);

    this.setActiveChannelId(channelId);
    goTo('/chat');
  }
}

const chatStore = new ChatStore();

resetAllStore.addResetMethod(chatStore.resetChat);

export { chatStore, ChatStore };
